import React, { Component } from "react";

import _ from "i18n";
import PeriodFilter from "../../Filters/EventStats/PeriodFilter";
import MonthFilter from "../../Filters/EventStats/MonthFilter";
import SaisonFilter from "../../Filters/EventStats/SaisonFilter";


export default class PageHeader extends Component {
  render() {
    const { header, subHeader, cssClass, icon, children, compon, periodFilter } = this.props;

    return (
      <div className={periodFilter ? "page_header event-page-header" : "page_header"}>
        <div className="page_header__icon">
          {icon &&  <img src={"/img/icons/" + icon +".svg"} alt={""} /> }
          {compon &&  <div className="flex">  {compon} </div> }

          {/*<SvgIcon icon={icon} className={""} />*/}
        </div>
        <div className="page_header__info">
          <div>
            <h3>{_(header)}</h3>
            <p>{_(subHeader)}</p>
          </div>
          {/*{periodFilter &&
          <div className={'flex'}>
            <PeriodFilter className={'ml-6 mt-1'}/>
            <SaisonFilter/>
            <MonthFilter/>
          </div>
          }*/}
        </div>
        <div className="page_header__children">{children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/common/PageHeader/PageHeader.js